// src/pages/AboutPage.js
import React from "react";
import { About } from "../components/about";

export const AboutPage = ({ data }) => {
  return (
    <div className="standalone-page">
      <About data={data} />
    </div>
  );
};